// extracted by mini-css-extract-plugin
module.exports = {"showAllContainer":"HighlightedEntityType_showAllContainer__5ceiR","list":"HighlightedEntityType_list__1ZL_A"};